import React from 'react';
import Loader from "react-loader-spinner";
import './CustomLoader.css';

const CustomLoader = ({ variant = "default", color = "#007bff", size = 40 }) => {
  return (
    <>
      <div className={`loader_alignment ${variant === "inline" ? "loader_inline" : ""}`}>
        <Loader
          type="TailSpin"
          color={color}
          height={size}
          width={size}
        />
      </div>
    </>
  )
}
export default CustomLoader